/** Numbers in Russian style everywhere in the UI: 16000 → "16 000". */
export function fmtNum(v: number | string | null | undefined): string {
  const n = Number(v ?? 0);
  return Number.isFinite(n) ? n.toLocaleString('ru-RU') : String(v ?? '');
}
